import type { ConnectionRunsSummary } from '../../shared/api-types.js';
import type { ConnectionSystem } from '../../shared/enums.js';
import { unattendedStreakText } from './lib/connection-runs.js';

// The rows the two integration sections share (design system 06-modules §6.4), spelled once so the Fellow and Slack
// panels cannot drift apart in markup. Each renders a `<dt>`/`<dd>` pair for the section's `<dl class="field-list">`.

/**
 * The Unattended streak row (§6.4): the count, and under it which trigger it counts. Why two elements and a stacking
 * rule (pages.css `.connection-run-streak`): the word and its detail had been two adjacent text nodes in one inline
 * `<dd>` and read as one run-on string — "None yetNo scheduled sync has completed…" (review of 2026-10-05, finding
 * 10). The surrounding idiom is the panel's "Ticking off in Fellow" row: the word, then the reason beneath.
 */
export function UnattendedStreakRow({ summary, system }: { summary: Pick<ConnectionRunsSummary, 'unattendedStreak'>; system: ConnectionSystem }) {
  const streak = unattendedStreakText(summary, system);
  return (
    <>
      <dt>Unattended streak</dt>
      <dd className="connection-run-streak" data-streak={summary.unattendedStreak}>
        <span className="connection-run-streak__word">{streak.word}</span>
        <span className="text-sm muted connection-run-streak__detail">{streak.detail}</span>
      </dd>
    </>
  );
}
